module.exports = __webpack_public_path__ + "img/li.22b3e727.svg";